import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-end pre-create-button-area w-100" }
const _hoisted_2 = { class: "button-with-error" }
const _hoisted_3 = { class: "error-message-area" }

import { ref, computed } from 'vue';
import { useAuth } from "@/services/user/Auth0UserProvider";
import i18n from '@/lang/i18n';
import Api from "@/services/api/ApiServiceFabrick";
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import { isLaravelValidationError } from '@/types/LaravelValidationError';


export default /*@__PURE__*/_defineComponent({
  __name: 'MonthlyReportPreCreateButtonArea',
  props: {
    operationOfficeId: {},
    yearMonth: {},
    showFlash: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const { loginWithRedirect } = useAuth();
const processing = ref(false);
const errorMessages = ref<string[]>([]);

const isDisabled = computed(() => {
  return processing.value || !props.operationOfficeId || !props.yearMonth;
});

async function handleBulkAggregate() {
  if (!props.operationOfficeId || !props.yearMonth) {
    return;
  }

  processing.value = true;
  errorMessages.value = [];
  try {
    await Api().createMonthlyReportPreCreate({
      operation_office_id: props.operationOfficeId,
      year_month: props.yearMonth
    });
    if (props.showFlash) {
      props.showFlash(
        i18n.global.t('pages.monthlyReport.preCreateButton.bulkAggregateStarted'),
        'success',
        true
      );
    }
  } catch (error: unknown) {
    if (isLaravelValidationError(error)) {
      const res = error.response;
      switch (res.status) {
        case 401:
          loginWithRedirect({ appState: { targetUrl: location.pathname } })
          break
        case 403:
          location.reload()
          break
        case 422:
          if (res.data.errors) {
            for (const msgs of Object.values(res.data.errors)) {
              errorMessages.value.push(...msgs);
            }
          }
          break;
      }
    } else {
      console.error(error);
    }
  } finally {
    processing.value = false;
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createBlock(_component_v_col, { class: "d-flex align-items-center" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            class: "exec-btn me-2",
            disabled: isDisabled.value,
            onClick: handleBulkAggregate
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.monthlyReport.preCreateButton.bulkAggregate')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ValidationErrors, { messages: errorMessages.value }, null, 8, ["messages"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})